export default [
  { name: 'Acre', abbreviation: 'AC', code: '12' },
  { name: 'Alagoas', abbreviation: 'AL', code: '27' },
  { name: 'Amapá', abbreviation: 'AP', code: '16' },
  { name: 'Amazonas', abbreviation: 'AM', code: '13' },
  { name: 'Bahia', abbreviation: 'BA', code: '29' },
  { name: 'Ceará', abbreviation: 'CE', code: '23' },
  { name: 'Distrito Federal', abbreviation: 'DF', code: '53' },
  { name: 'Espírito Santo', abbreviation: 'ES', code: '32' },
  { name: 'Goiás', abbreviation: 'GO', code: '52' },
  { name: 'Maranhão', abbreviation: 'MA', code: '21' },
  { name: 'Mato Grosso', abbreviation: 'MT', code: '51' },
  { name: 'Mato Grosso do Sul', abbreviation: 'MS', code: '50' },
  { name: 'Minas Gerais', abbreviation: 'MG', code: '31' },
  { name: 'Pará', abbreviation: 'PA', code: '15' },
  { name: 'Paraíba', abbreviation: 'PB', code: '25' },
  { name: 'Paraná', abbreviation: 'PR', code: '41' },
  { name: 'Pernambuco', abbreviation: 'PE', code: '26' },
  { name: 'Piauí', abbreviation: 'PI', code: '22' },
  { name: 'Rio de Janeiro', abbreviation: 'RJ', code: '33' },
  { name: 'Rio Grande do Norte', abbreviation: 'RN', code: '24' },
  { name: 'Rio Grande do Sul', abbreviation: 'RS', code: '43' },
  { name: 'Rondônia', abbreviation: 'RO', code: '11' },
  { name: 'Roraima', abbreviation: 'RR', code: '14' },
  { name: 'Santa Catarina', abbreviation: 'SC', code: '42' },
  { name: 'São Paulo', abbreviation: 'SP', code: '35' },
  { name: 'Sergipe', abbreviation: 'SE', code: '28' },
  { name: 'Tocantins', abbreviation: 'TO', code: '17' },
];
